import './App.css';
import HookCounter from './components/HookCounter';


function App() {
  return (
    <>
      <HookCounter />
    </>
  );
}

export default App;
